import { useEffect, useState } from 'react';

import useTranslate from '@root/core/hooks/useTranslate';
import wareHouseService from '@root/modules/Warehouse/Dasboard/services/warehouse';
import { Card } from 'antd';
import RowItem from './row-list/RowItem';

function OrderStatus({ setLoading }: any) {
  let [list, setList] = useState([] as any);
  const WAREHOUSE_ORDER_LIST = [
    {
      id: 1,
      itemName: 'Inquiry',
      status: 'Order Status',
      numPro: `${list?.inquiry}`,
      url: '/admin/inquiry'
    },
    {
      id: 2,
      itemName: 'Inbound',
      status: 'Order Status',
      numPro: `${list?.inbound}`,
      url: '/admin/inbound'
    },
    {
      id: 3,
      itemName: 'Delivery',

      status: 'Order Status',
      numPro: `${list?.delivery}`,
      url: '/admin/delivery'
    },
    {
      id: 4,
      itemName: 'Return/Disposal',

      status: 'Order Status',
      numPro: `${list?.disposal}`,
      url: '/admin/return'
    }
  ];

  const [t] = useTranslate();

  /*------------api list total-----------------*/

  const getListOrderToday = async () => {
    setLoading(true);
    const warehouse = await wareHouseService.getListOrderToday();
    setList(warehouse?.data?.totalInfoToday);
    setLoading(false);
  };

  useEffect(() => {
    getListOrderToday();
  }, []);

  /*------------UTC day-----------------*/

  const date = new Date();

  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const day = String(date.getUTCDate()).padStart(2, '0');

  const strDate = year + '/' + month + '/' + day + ' ';

  return (
    <>
      <Card
        style={{ marginRight: '50px', height: 'fit-content', width: '50%' }}
        className="cardList listOrder"
        type="inner"
        title="Order status today"
        extra={strDate}
      >
        {WAREHOUSE_ORDER_LIST.map((item, index) => (
          <>
            <RowItem
              itemName={t(item.itemName)}
              status={t(item.status)}
              numPro={item.numPro}
              url={item.url}
            />{' '}
          </>
        ))}
      </Card>
    </>
  );
}

export default OrderStatus;
